<template>
  <div class="input_One_box">
    <!-- 公用组件  -->
    <div class="input_one" @dblclick="dblclick" :class="isactive?'input_one_active':''">
      <span class="label_name" :class="isMust?'isMust':''">{{name}}</span>
      <!-- <i class="el-icon-question icon_styICON"  v-if="isquestion"></i> -->
      <el-input
        v-model="value1"
        size="mini"
        :clearable="true"
        class="input_sty"
        id="WarehouseFullName"
        ref="WarehouseFullName"
        :auto-complete="complete==false?'new-password':''"
        @focus="doFocus($event)"
        @blur="inputFocus"
        :disabled="isdisable"
        :placeholder="placeholder"
        @input="changeValdata(value)"
        :show-password="password"
      ></el-input>
      <i v-if="icon1" class="icon_styICON el-icon-plus" @click="$emit('clickAdd')"></i>
      <i v-if="icon2" class="icon_styICON2 el-icon-search" @click="$emit('clickSearch')"></i>
      <i
        v-if="icon3"
        :class="icon1==true?'icon_styICON3_1':'icon_styICON3'"
        class="el-icon-circle-close"
        @click="$emit('clickclose')"
      ></i>
    </div>
    <!-- 验证提示 -->
    <div v-if="error||serror" class="invalid-feedbac">{{error||serror}}</div>
  </div>
</template>

<script>
export default {
  name: "InputOne",
  data() {
    return {
      value1: this.value,
      isactive: false,
      showpassword: this.password,
      icon: this.icon1,
      icons: this.icon2,
      iconss: this.icon3,
      errors: this.error,
      serror: "",
      offon: true
    };
  },
  methods: {
    childAction() {
      this.$refs.WarehouseFullName.focus();
    },
    // 双击事件
    dblclick() {
      if (this.isdisable) {
        this.$emit("dblclick");
      }
    },
    // 聚焦事件
    doFocus() {
      this.$emit("clickFocus");
      this.isactive = true;
      event.currentTarget.select();
    },
    // 失焦事件
    inputFocus() {
      this.$emit("Blur", this.value1);
      this.isactive = false;
      // console.log(this.error);
    },

    // 绑定input事件进行回调传值
    changeValdata(val) {
      // this.$emit("changeVal", this.value1, this.field);
      switch (this.reg) {
        case "text": //任意值
          break;
        case "float": //小数
          this.value1 = this.value1.replace(
            /^\D*(\d*(?:\.\d{0,6})?).*$/g,
            "$1"
          );
          break;
        case "integer": //正整数
          this.value1 = this.value1.replace(/[^\d]/g, "");
          if (!this.value1) {
            this.serror = "";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "phone": //手机号
          if (!this.value1) {
            this.serror = "";
          } else if (!/^1[345678]\d{9}$/.test(this.value1)) {
            this.serror = "请输入正确是手机号";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "empty": //任意值  但不能为空
          if (!this.value1) {
            this.serror = "";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "Man":
          if (!this.value1) {
            this.serror = "";
          } else if (!/[\u4E00-\u9FA5]/g.test(this.value1)) {
            this.serror = "可以输入除汉字以外的任意字符";
            // return true;
          } else {
            this.serror = "";
            return true;
          }

          break;
        default:
          break;
      }
    }
  },

  created() {},
  mounted() {
    this.$on("footer", val => {
      this.childAction(ind);
    });
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    error: {
      type: String,
      default: ""
    }, //验证不正确提示
    password: {
      type: Boolean,
      default: false
    },
    reg: {
      type: String,
      default: "text"
    },
    // placeholder: String,
    value: [String, Number],
    name: {
      type: String,
      default: "客户"
    },
    isMust: {
      type: Boolean,
      default: true
    },
    // isShow: {
    //   type: Boolean
    //   // default: false
    // },
    icon1: {
      type: Boolean,
      default: false
    },

    icon2: {
      type: Boolean,
      default: false
    },
    icon3: {
      type: Boolean,
      default: false
    },
    isdisable: {
      type: Boolean,
      default: false
    },
    // 传入的外部字段，将用于传出识别
    field: { type: String }
  },
  watch: {
    value() {
      this.value1 = this.value;
      // console.log('66547')
    },
    value1() {
      this.$emit("changeVal", this.value1, this.field);
    }
  }
};
</script>

<style lang="less">
.input_one {
  width: 100%;
  height: 26px;
  display: flex;
  justify-content: flex-end;
  position: relative;
  border: 1px solid #d6e2ed;
  border-radius: 5px;
  padding-right: 0 !important;
  overflow: hidden;
  .el-input--suffix {
    width: 100%;
    position: relative;

    .el-input__inner {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      height: 26px;
      line-height: 26px;
      padding: 0;
      text-indent: 14px;
      font-size: 13px;
      // color: #065 !important;
    }
  }

  .label_name {
    color: #000;
    height: 100%;
    text-align: center;
    white-space: nowrap;
    line-height: 26px;
    font-size: 14px;
    margin-left: 5px;
    font-weight: bold;
  }
  .isMust::after {
    content: "*";
    color: red;
  }
  .input_sty {
    position: relative;
    -webkit-box-flex: 1;
    box-flex: 1;
    display: block;
    height: 100%;
    .el-input__inner {
      color: #000;
    }
  }
  .icon_styICON {
    cursor: pointer;
    display: block;
    margin-left: 14px;
    position: absolute;
    top: 6px;
    right: 30px;
  }
  .icon_styICON2 {
    cursor: pointer;
    display: block;
    margin-left: 14px;
    position: absolute;
    top: 6px;
    right: 7px;
  }
  .icon_styICON3 {
    cursor: pointer;
    display: block;
    margin-left: 14px;
    position: absolute;
    color: #ccc;
    top: 6px;
    right: 30px;
    display: none;
  }
  .icon_styICON3_1 {
    cursor: pointer;
    display: block;
    margin-left: 14px;
    color: #ccc;
    position: absolute;
    top: 6px;
    right: 50px;
    display: none;
  }
}
.input_One_box {
  position: relative;
  .invalid-feedbac {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 7px;
    height: 16px;
    line-height: 16px;
    position: absolute;
  }
}
.icon_styICON:hover {
  color: #2594ff !important;
}
.icon_styICON2:hover {
  color: #2594ff !important;
}
.icon_styICON3:hover {
  color: #2594ff !important;
}
.icon_styICON3_1:hover {
  color: #2594ff !important;
}
.input_one:hover {
  border-color: #2594ff;
  color: #2594ff;
  .icon_styICON {
    color: #000;
  }
  .icon_styICON2 {
    color: #000;
  }
  .icon_styICON3 {
    display: block;
    color: #000;
  }
  .icon_styICON3_1 {
    display: block;
    color: #000;
  }
}
.input_one_active {
  border-color: #2594ff !important;
  color: #2594ff !important;
}
// input {
//   color: #fff !important;
// }
</style>


// WEBPACK FOOTER //
// src/components/Input/InputOne/InputOne.vue